import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const ServiceIntellWidgets = {
  getList: async () => {
    try {
      const response = await apiService.get("/servicesintellwidgets");
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/servicesintellwidgets/${id}`,
        updatedData,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  create: async (data) => {
    const response = await apiService.post("/servicesintellwidgets", data);
    return response.data;
  },

  getdetail: async (id) => {
    const response = await apiService.get(`/servicesintellwidgets/byservice/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/servicesintellwidgets/${id}`);
    return response.data;
  },
  deleteMain: async (id) => {
    const response = await apiService.delete(`/servicesintellwidgets/delete-main/${id}`);
    return response.data;
  },
};

export default ServiceIntellWidgets;
